import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { isEqual } from "lodash";
import { createSelectorCreator, defaultMemoize } from "reselect";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import settingsReducer from "./settings/settingsSlice";
import sernumsReducer from "./sernums/sernums.slice";

export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, {
  equalityCheck: isEqual,
  maxSize: 20,
  resultEqualityCheck: isEqual
});

const prefix = "@estimator";

const settingsConfig = {
  key: `${prefix}_settings_config`,
  storage,
  blacklist: ["units", "currency"]
};

const reducer = {
  settings: persistReducer(settingsConfig, settingsReducer),
  sernums: sernumsReducer
};

const ignoredActions = [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER];
const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions
      }
    }),
  devTools: process.env.NODE_ENV !== "production"
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
